export default function useAdmin() {
  const header = {
    headers: {
      //Authorization: `Bearer ${admin.accessToken}`,
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };

  return {
    header,
  };
}
